var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5428_13741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42775 11.3138L19.7987 11.3138M9.42775 11.3138L7.77784 16.2635C7.75339 16.3294 7.74835 16.4008 7.76331 16.4694C7.77828 16.538 7.81263 16.6009 7.86228 16.6505C7.91192 16.7001 7.97478 16.7345 8.04338 16.7495C8.11197 16.7644 8.18343 16.7594 8.24924 16.7349L19.7987 11.3138M9.42775 11.3138L7.77784 6.36404C7.75339 6.29822 7.74835 6.22677 7.76331 6.15818C7.77828 6.08958 7.81263 6.02672 7.86228 5.97708C7.91192 5.92743 7.97478 5.89308 8.04338 5.87811C8.11197 5.86314 8.18342 5.86818 8.24924 5.89264L19.7987 11.3138",
    stroke: "#354052",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5428_13741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.3135) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDefault);
export default __webpack_public_path__ + "static/media/send-default.6f26706ab8680b30fcf171878504e9cb.svg";
export { ForwardRef as ReactComponent };